import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  connected$: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient) {
  }

  connected() {
    this.connected$.next(true);
  }

  disconnected() {
    this.connected$.next(false);
  }

  ping() {
    const headers = new HttpHeaders();
    headers.set('Ping', 'true');
    return this.http.head('/', {
      headers,
    }).pipe(map(result => result));
  }

}
